import client from "/src/services/client";

export default {
    getPhoneContext: async (params = {}) => {
        const [response, error] = await client.get(`telephony/phone-context`);
        if (error != null) {
            return [response, error];
        }

        let rows = Object.entries(response || {}).map(([number, data]) => ({
            number,
            current_call: data.current_call ?? 0,
            max_simultaneous_call: data.max_simultaneous_call ?? 0,
        }));

        if (params.number) {
            rows = rows.filter((row) => row.number.includes(params.number));
        }

        return [rows, null];
    },
};
